type Props = {
	untrackedDayCount: number | null | undefined;
};

// `null` is a month that is not the current month, `0` is a month with nothing left to book.
export function UntrackedDaysHint({ untrackedDayCount }: Props) {
	if (!untrackedDayCount) return null;

	return (
		<p className="mb-3 text-sm text-gray-700">
			Du musst noch <span className="font-bold">{untrackedDayCount}</span> {untrackedDayCount === 1 ? "Tag" : "Tage"} für diesen Monatsabschluss buchen
		</p>
	);
}
